import dayjs from 'dayjs';

import { GanttSelectionState } from '../../store/atom';

import { Task } from '@/features/saveSite/types';
import { DataFile, DataFileType } from '@/features/siteTop/types';

/**
 * FrappeGanttのdateからイベントから値を受け取り、GanttSelectionの値に変換する
 */
export const convertFrappeGanttDateToGanttSelection = (
  date: string,

  currentGanttSelection: GanttSelectionState | null,
  asBuiltDataFiles: DataFile[]
): GanttSelectionState => {
  //currentGanttSelectionから、dateが一致するものを削除または追加
  const newGanttSelection: GanttSelectionState = {
    ...currentGanttSelection,
  };
  //すでに選択されているものがあるか
  const isExist = newGanttSelection.date?.dataFile.measurementDate === date;
  if (isExist) {
    //すでに選択されているものを削除
    newGanttSelection.date = undefined;
  } else {
    const sameMeasurementDateAsBuiltDataFiles = asBuiltDataFiles.filter(
      (dataFile) => dataFile.measurementDate === date
    );
    /**
     * 複数ある場合は、優先順位付けする
     * 起工測量 > 出来高
     */
    const dataFile = (() => {
      if (sameMeasurementDateAsBuiltDataFiles.length === 1)
        return sameMeasurementDateAsBuiltDataFiles[0];
      //起工測量
      const groundSurveyDataFile = sameMeasurementDateAsBuiltDataFiles.find(
        (d) => d.typeId === DataFileType.GROUND_SURVEY_LIGHT
      );
      if (groundSurveyDataFile) return groundSurveyDataFile;
      //出来高とみなす
      return sameMeasurementDateAsBuiltDataFiles[0];
    })();

    //新たに選択されたものを追加
    newGanttSelection.date = {
      dataFile,
      //unixtime
      selectedDateTime: dayjs().unix(),
    };
  }
  return {
    ...newGanttSelection,
    updatedAt: dayjs().unix(),
  };
};

/**
 * FrappeGanttのcrossからイベントから値を受け取り、GanttSelectionの値に変換する
 */
export const convertFrappeGanttCrossToGanttSelection = (
  cross: {
    taskId: number;
    date: string;
  },
  currentGanttSelection: GanttSelectionState | null,
  asBuiltDataFiles: DataFile[],
  allTasks: Task[]
): GanttSelectionState => {
  //currentGanttSelectionから、dateが一致するものを削除または追加
  const newGanttSelection: GanttSelectionState | null = {
    ...currentGanttSelection,
  };

  //すでに選択されているものがあるか
  const isExist = newGanttSelection?.crosses?.find(
    (c) => c.dataFile.measurementDate === cross.date && c.task.id === cross.taskId
  );
  if (isExist) {
    //すでに選択されているものを削除(measurementDateとtaskIdが一致するものを削除)
    newGanttSelection.crosses = newGanttSelection.crosses?.filter(
      (c) => c.dataFile.measurementDate !== cross.date || c.task.id !== cross.taskId
    );
  } else {
    const sameMeasurementDateAsBuiltDataFiles = asBuiltDataFiles.filter(
      (dataFile) => dataFile.measurementDate === cross.date
    );
    /**
     * 複数ある場合は、優先順位付けする
     * 起工測量 > 出来高
     */
    const dataFile = (() => {
      if (sameMeasurementDateAsBuiltDataFiles.length === 1)
        return sameMeasurementDateAsBuiltDataFiles[0];
      //起工測量
      const groundSurveyDataFile = sameMeasurementDateAsBuiltDataFiles.find(
        (d) => d.typeId === DataFileType.GROUND_SURVEY_LIGHT
      );
      if (groundSurveyDataFile) return groundSurveyDataFile;
      //出来高とみなす
      return sameMeasurementDateAsBuiltDataFiles[0];
    })();
    //新たに選択されたものを追加
    newGanttSelection.crosses = [
      ...(newGanttSelection.crosses || []),
      {
        task: allTasks.find((task) => task.id === cross.taskId) as Task,
        dataFile,
        selectedDateTime: dayjs().unix(),
      },
    ];
  }
  return {
    ...newGanttSelection,
    updatedAt: dayjs().unix(),
  };
};
